import React from "react";
import { inject, observer } from "mobx-react";
import { Button, CircularProgress } from "@material-ui/core";
import { withRouter, Link } from "react-router-dom";
import _ from "lodash";

import "./auth/AuthPages.css";

import { Auth } from "aws-amplify";
import agent from "../agent.js"
import { ProfileType } from "../types/enum";
import WarningModal from "../components/modal/WarningModal";
import logo from "../img/hotgig-logo.png";
import backgroundImage from "../img/background-images-2025.jpg";

const EMAIL_CONFIRMATION_REQUIRED = process.env.REACT_APP_EMAIL_CONFIRMATION_REQUIRED === "true";

@inject("authStore", "facebookStore", "generalProfileStore", "userInvitationStore", "profileStore")
@withRouter
@observer
class Register extends React.Component {
    params = undefined;
    _isMounted = false;

    constructor(props) {
        super(props);
        this.state = {
            source: undefined,
            params: undefined,
            email: "",
            password: "",
            checked: false,
            subscribeEmail: '',
            as: undefined,
            isLoading: false,
            showPassword: false,
            isEmailInvalid: false,
            tokenUsed: false
        };
    }

    componentDidMount() {
        this._isMounted = true;
        this.props.authStore.reset();
        if (this.props.location && this.props.location.search) {
            this.params = _.chain(this.props.location.search)
                .replace("?", "")
                .split("&")
                .map(_.ary(_.partial(_.split, _, "="), 1))
                .fromPairs()
                .mapValues(v => { try { return decodeURIComponent(v); } catch (e) { return v; } })
                .value();

            if (this.params.email) {
                this.props.authStore.setEmail(this.params.email);
            }

            if (this.params.firstName) {
                this.props.authStore.setFirstname(this.params.firstName);
            }

            if (this.params.lastName) {
                this.props.authStore.setLastname(this.params.lastName);
            }

            if (this.params.source) {
                this.setState({
                    ...this.state,
                    source: this.params.source
                });
            }
            if (this.params.as) {
                this.setState({
                    ...this.state,
                    as: this.params.as
                });
            }

            if (this.params.applyToPlay) {
                sessionStorage.setItem('referralAgentId', this.params.applyToPlay);
            }

            if (this.params.token && this.params.email) {
                Auth.signIn(this.params.email, this.params.token)
                    .then(user => {
                        if (user && user.challengeName === "NEW_PASSWORD_REQUIRED") {
                            return;
                        }
                        Auth.signOut().catch(() => {});
                        if (this._isMounted) {
                            this.setState({ tokenUsed: true });
                            this._redirectTimer = setTimeout(() => {
                                if (this._isMounted) {
                                    this.props.history.replace("/sign-in");
                                }
                            }, 3000);
                        }
                    })
                    .catch(err => {
                        if (err.code === "NotAuthorizedException" && this._isMounted) {
                            this.setState({ tokenUsed: true });
                            this._redirectTimer = setTimeout(() => {
                                if (this._isMounted) {
                                    this.props.history.replace("/sign-in");
                                }
                            }, 3000);
                        }
                    });
            }
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
        if (this._redirectTimer) {
            clearTimeout(this._redirectTimer);
        }
        this.props.authStore.reset();
    }

    handleClickShowPassword = () => {
        const { showPassword } = this.state
        this.setState({ showPassword: !showPassword })
    }

    handleEmailChange = e => this.props.authStore.setEmail(e.target.value);
    handleValidateEmail = e => this.props.authStore.validateEmail(e.target.value);
    handleFirstnameChange = e => this.props.authStore.setFirstname(e.target.value);
    handleValidateFirstName = e => this.props.authStore.validateFirstName(e.target.value);
    handleLastnameChange = e => this.props.authStore.setLastname(e.target.value);
    handleValidateLastName = e => this.props.authStore.validateLastName(e.target.value);
    handlePasswordChange = e => this.props.authStore.setPassword(e.target.value)
    handleValidatePassword = e => this.props.authStore.validatePassword(e.target.value)
    handleConfirmPasswordChange = (e) => this.props.authStore.setConfirmPassword(e.target.value)
    handleValidateConfirmPassword = (e) => this.props.authStore.validateConfirmPasswor(e.target.value)

    handleSubmitForm = async e => {
        const { match } = this.props;
        var referralCode = match.params.referralCode
        e.preventDefault();
        const { source, as } = this.state;
        this.setState({ isLoading: true })
        this.props.authStore.checkEmailValid().then(async (isValid) => {
            if (isValid || process.env.REACT_APP_DISABLE_DISPOSABLE_EMAIL === "false") {
                this.props.authStore.register(this.params ? this.params.token : undefined, source, as).then(async user => {
                    
                    const referralAgentId = sessionStorage.getItem('referralAgentId');

                    const userName = user.username;

                    if (referralAgentId && userName) {
                        try {
                            await this.props.profileStore.createApplyToPlayCustomRegisterUser(userName, referralAgentId);
                        } catch (err) {
                            console.error("Error saving applyToPlay referral:", err);
                        } finally {
                            sessionStorage.removeItem('referralAgentId');
                        }
                    }

                    this.setState({ isLoading: false })
                    if (this.params && this.params.as && this.params.as === "changeEmail") {
                        const profile = this.props.profileStore.getCurrentProfile();
                        this.gotoDashboard(profile.type)
                    } else if (EMAIL_CONFIRMATION_REQUIRED && referralCode) {
                        Promise.all([
                            this.props.profileStore.createReferralProfile(referralCode, user.username),
                        ]).then(() => {
                            localStorage.setItem("email-confirmation", this.props.authStore.values.email)
                            this.props.history.push(`/confirmation`);
                        });
                    }
                    else if (EMAIL_CONFIRMATION_REQUIRED && this.params?.token === undefined) {
                        localStorage.setItem("email-confirmation", this.props.authStore.values.email)
                        this.props.history.push(`/confirmation`);
                    } else if (user.status === 50 && (this.params.as === "staff" || this.params.as === "AgentVenues")) {
                        if (this.params.as === "AgentVenues") {
                            let candidateCustomer = {
                                userId: user.sub,
                                email: this.params.email,
                                given_name: this.params.firstName,
                                family_name: this.params.lastName,
                                userType: 3
                            };
                            await agent.Billing.createCustomer(candidateCustomer);
                        }
                        Promise.all([
                            this.props.profileStore.loadProfilesAfterLogin(),
                        ]).then(() => {
                            this.props.history.push("/staff/edit/" + user.profileId);
                        });
                    } else if (user.status === 50 && this.params.as === "VenuesAgent") {
                        let candidateCustomer = {
                            userId: user.sub,
                            email: this.params.email,
                            given_name: this.params.firstName,
                            family_name: this.params.lastName,
                            userType: 2
                        };
                        await agent.Billing.createCustomer(candidateCustomer);
                        Promise.all([
                            this.props.profileStore.loadProfilesAfterLogin(),
                        ]).then(() => {
                            this.props.history.push("/agent/edit/" + user.profileId);
                        });
                    } else if (user.status === 50 && this.params.as === "consultant") {
                        this.props.history.push("/agent/edit");
                    } else if (user.status === 50) {
                        this.props.history.push("/welcome");
                    } else if (user && typeof user.status !== undefined && this.params.as === "staff") {
                        this.props.history.push("/staff/edit/new");
                    } else if (user && typeof user.status !== undefined && this.params.as.toLowerCase().includes('act')) {
                        let candidateCustomer = {
                            userId: user.sub,
                            email: this.params.email,
                            given_name: this.params.firstName,
                            family_name: this.params.lastName,
                            userType: 1
                        };
                        await agent.Billing.createCustomer(candidateCustomer);
                        Promise.all([
                            this.props.profileStore.loadProfilesAfterLogin(),
                        ]).then(() => {
                            this.props.profileStore.setProfileType(ProfileType.Musician.ordinal);
                            this.props.history.push("/musician/edit/new");
                        });
                    } else if (this.params && user.isInvited) {
                        if (this.params.as) {
                            this.props.history.replace(`/welcome/${this.params.as}/${user.profileId}`);
                        } else {
                            this.props.history.replace("/welcome/musician");
                        }
                    } else if (source) {
                        this.props.history.replace("/welcome/musician");
                    } else {
                        this.props.history.push("/welcome");
                    }
                })
                    .catch(err => {
                        console.log("error", err)
                        this.setState({ isLoading: false })
                    })
            } else {
                this.setState({ isLoading: false })
                this.openModal()
            }
        })
    };

    gotoDashboard(profileType) {
        switch (profileType) {
            case 1:
                this.props.history.push("/musician");
                break;
            case 2:
                this.props.history.push("/agent");
                break;
            case 3:
                this.props.history.push("/staff");
                break;
            case 6:
                this.props.history.push("/production");
                break;
            case 7:
                this.props.history.push("/dj");
                break;
            case 8:
                this.props.history.push("/agent");
                break;
            default:
                this.props.history.push("/welcome");
                break;
        }
    }

    anyError(field) {
        if (!this.props.authStore.errors) return false;
        if (!this.props.authStore.errors[field]) return false;
        return true;
    }

    errorText(field) {
        if (!this.props.authStore.errors) return null;
        if (!this.props.authStore.errors[field]) return null;
        return this.props.authStore.errors[field].replace(/([a-z](?=[A-Z]))/g, "$1 ");
    }

    handleCheckBox = (e) => {
        this.setState({ checked: e.target.checked })
    }

    openModal = () => {
        this.setState({ isEmailInvalid: true })
    }

    closeModal = () => {
        this.setState({ isEmailInvalid: false })
    }

    handleTextCheckBox = () => {
        this.setState({ checked: !this.state.checked })
    }

    render() {
        const { values, errors } = this.props.authStore;
        const { showPassword, tokenUsed } = this.state;
        let isChangeEmail = this.state.as === "changeEmail";

        if (tokenUsed) {
            return (
                <div className="auth-page" style={{ backgroundImage: `url(${backgroundImage})` }}>
                    <div className="auth-container signup-container">
                        <div className="auth-card">
                            <div className="auth-header">
                                <div className="auth-logo">
                                    <img src={logo} alt="Hot Giggity" className="auth-logo-img" />
                                </div>
                            </div>
                            <div className="auth-content" style={{ textAlign: "center", padding: "40px 20px" }}>
                                <svg viewBox="0 0 24 24" fill="none" stroke="#ff5722" strokeWidth="2" style={{ width: 48, height: 48, marginBottom: 16 }}>
                                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                                </svg>
                                <h1 className="auth-title">Already Registered</h1>
                                <p className="auth-subtitle">This invitation has already been used. Redirecting you to the login page...</p>
                                <div style={{ marginTop: 24 }}>
                                    <CircularProgress size={24} />
                                </div>
                                <div className="auth-footer" style={{ marginTop: 24 }}>
                                    <p><Link to="/sign-in">Click here</Link> if you are not redirected automatically.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className="auth-page" style={{ backgroundImage: `url(${backgroundImage})` }}>
                <div className="auth-container signup-container">
                    <div className="auth-card">
                        <div className="auth-header">
                            <div className="auth-logo">
                                <img src={logo} alt="Hot Giggity" className="auth-logo-img" />
                            </div>
                        </div>

                        <div className="auth-content">
                            <div className="signup-badge">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                                    <circle cx="8.5" cy="7" r="4"></circle>
                                    <line x1="20" y1="8" x2="20" y2="14"></line>
                                    <line x1="23" y1="11" x2="17" y2="11"></line>
                                </svg>
                                <span>Create your account</span>
                            </div>

                            <h1 className="auth-title">Join Hot Giggity</h1>
                            <p className="auth-subtitle">Create your free account to get started</p>

                            <form className="auth-form" onSubmit={this.handleSubmitForm}>
                                {this.anyError("general") && (
                                    <div className="auth-error-message">
                                        {this.errorText("general")}
                                    </div>
                                )}

                                <div className="auth-form-row">
                                    <div className="auth-form-group">
                                        <label htmlFor="firstName">First Name</label>
                                        <div className="auth-input-wrapper">
                                            <svg className="auth-input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                                                <circle cx="12" cy="7" r="4"></circle>
                                            </svg>
                                            <input
                                                id="firstName"
                                                type="text"
                                                className={`auth-native-input ${this.anyError("firstName") ? 'has-error' : ''}`}
                                                placeholder="First name"
                                                value={values.firstName}
                                                onChange={this.handleFirstnameChange}
                                                onBlur={this.handleValidateFirstName}
                                                readOnly={isChangeEmail}
                                            />
                                        </div>
                                        {this.anyError("firstName") && (
                                            <span className="auth-field-error">{this.errorText("firstName")}</span>
                                        )}
                                    </div>
                                    <div className="auth-form-group">
                                        <label htmlFor="lastName">Last Name</label>
                                        <div className="auth-input-wrapper">
                                            <svg className="auth-input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                                                <circle cx="12" cy="7" r="4"></circle>
                                            </svg>
                                            <input
                                                id="lastName"
                                                type="text"
                                                className={`auth-native-input ${this.anyError("lastName") ? 'has-error' : ''}`}
                                                placeholder="Last name"
                                                value={values.lastName}
                                                onChange={this.handleLastnameChange}
                                                onBlur={this.handleValidateLastName}
                                                readOnly={isChangeEmail}
                                            />
                                        </div>
                                        {this.anyError("lastName") && (
                                            <span className="auth-field-error">{this.errorText("lastName")}</span>
                                        )}
                                    </div>
                                </div>

                                <div className="auth-form-group">
                                    <label htmlFor="email">Email Address</label>
                                    <div className="auth-input-wrapper">
                                        <svg className="auth-input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                            <rect x="3" y="5" width="18" height="14" rx="2"></rect>
                                            <polyline points="3 7 12 13 21 7"></polyline>
                                        </svg>
                                        <input
                                            id="email"
                                            type="email"
                                            className={`auth-native-input ${this.anyError("email") ? 'has-error' : ''}`}
                                            placeholder="Enter your email"
                                            value={values.email}
                                            onChange={this.handleEmailChange}
                                            onBlur={this.handleValidateEmail}
                                            readOnly={this.params && this.params.email}
                                        />
                                    </div>
                                    {this.anyError("email") && (
                                        <span className="auth-field-error">{this.errorText("email")}</span>
                                    )}
                                </div>

                                <div className="auth-form-row">
                                    <div className="auth-form-group">
                                        <label htmlFor="password">Password</label>
                                        <div className="auth-input-wrapper">
                                            <svg className="auth-input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                                                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                                            </svg>
                                            <input
                                                id="password"
                                                type={showPassword ? 'text' : 'password'}
                                                className={`auth-native-input ${this.anyError("password") ? 'has-error' : ''}`}
                                                placeholder="Create password"
                                                value={values.password}
                                                onChange={this.handlePasswordChange}
                                                onBlur={this.handleValidatePassword}
                                            />
                                            <button
                                                type="button"
                                                className="auth-password-toggle-native"
                                                onClick={this.handleClickShowPassword}
                                                aria-label="toggle password visibility"
                                            >
                                                {showPassword ? (
                                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                                                        <circle cx="12" cy="12" r="3"></circle>
                                                    </svg>
                                                ) : (
                                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                                        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                                                        <line x1="1" y1="1" x2="23" y2="23"></line>
                                                    </svg>
                                                )}
                                            </button>
                                        </div>
                                        {this.anyError("password") && (
                                            <span className="auth-field-error">{this.errorText("password")}</span>
                                        )}
                                    </div>

                                    <div className="auth-form-group">
                                        <label htmlFor="confirmPassword">Confirm Password</label>
                                        <div className="auth-input-wrapper">
                                            <svg className="auth-input-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                                                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                                            </svg>
                                            <input
                                                id="confirmPassword"
                                                type={showPassword ? 'text' : 'password'}
                                                className={`auth-native-input ${this.anyError("confirmPassword") ? 'has-error' : ''}`}
                                                placeholder="Confirm password"
                                                value={values.confirmPassword}
                                                onChange={this.handleConfirmPasswordChange}
                                                onBlur={this.handleValidateConfirmPassword}
                                            />
                                            <button
                                                type="button"
                                                className="auth-password-toggle-native"
                                                onClick={this.handleClickShowPassword}
                                                aria-label="toggle password visibility"
                                            >
                                                {showPassword ? (
                                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                                        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                                                        <circle cx="12" cy="12" r="3"></circle>
                                                    </svg>
                                                ) : (
                                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                                        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                                                        <line x1="1" y1="1" x2="23" y2="23"></line>
                                                    </svg>
                                                )}
                                            </button>
                                        </div>
                                        {this.anyError("confirmPassword") && (
                                            <span className="auth-field-error">{this.errorText("confirmPassword")}</span>
                                        )}
                                    </div>
                                </div>

                                <div className="auth-checkbox-wrapper" onClick={this.handleTextCheckBox}>
                                    <input
                                        type="checkbox"
                                        className="auth-native-checkbox"
                                        checked={this.state.checked}
                                        onChange={this.handleCheckBox}
                                        onClick={(e) => e.stopPropagation()}
                                    />
                                    <span className="auth-checkbox-label">
                                        I agree to the <Link to="/policy" target="_blank" onClick={(e) => e.stopPropagation()}>Privacy Policy</Link> and <Link to="/tos" target="_blank" onClick={(e) => e.stopPropagation()}>Terms & Conditions</Link>
                                    </span>
                                </div>

                                {this.state.isLoading ? (
                                    <div className="auth-loading">
                                        <CircularProgress />
                                    </div>
                                ) : (
                                    <Button
                                        className="auth-btn-primary"
                                        variant="contained"
                                        type="submit"
                                        disabled={!this.state.checked}
                                    >
                                        <span>{isChangeEmail ? "Save" : "Create Account"}</span>
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                            <line x1="5" y1="12" x2="19" y2="12"></line>
                                            <polyline points="12 5 19 12 12 19"></polyline>
                                        </svg>
                                    </Button>
                                )}
                            </form>

                            <div className="auth-footer">
                                <p>Already have an account? <Link to="/sign-in">Sign in here</Link></p>
                            </div>
                        </div>
                    </div>

                    <div className="auth-promo">
                        <div className="promo-content">
                            <div className="promo-icon">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                                </svg>
                            </div>
                            <h2>Join Thousands of Users Worldwide</h2>
                            <p>The trusted platform for musicians, agents, venues, and event organisers worldwide.</p>
                            <ul className="promo-features">
                                <li>
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <polyline points="20 6 9 17 4 12"></polyline>
                                    </svg>
                                    <span>Bookings, agreements, invoices, and messaging — all in one place</span>
                                </li>
                                <li>
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <polyline points="20 6 9 17 4 12"></polyline>
                                    </svg>
                                    <span>Cut hours of admin from your week</span>
                                </li>
                                <li>
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <polyline points="20 6 9 17 4 12"></polyline>
                                    </svg>
                                    <span>Build your network with the right people</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>



                <WarningModal
                    title={"Warning: Temporary Email Address Detected"}
                    open={this.state.isEmailInvalid}
                    message={`<p>We have detected that you are trying to sign up using a temporary email address. Our platform requires a verifiable email address for registration to ensure the security and reliability of our services. Please use a permanent email address to create your account.</p>
                    <p>If you believe this is an error, or if you need assistance, please contact our support team at support@hotgiggity.com.</p>`}
                    closeHandler={this.closeModal}
                    confirmationLabel="Ok"
                />
            </div>
        );
    }
}

export default Register;
